export enum AppRoutes {
  welcome = "welcome",
  login = "login",
  map = "map",
}

export enum ModalIds {
  MapModal = "map-modal",
  ProfileModal = "profile-modal",
  LegendModal = "legend-modal",
}

export enum MapLayers {
  OpenStreetMaps = "OpenStreetMaps",
  BiN = "BiN",
}

export enum BaseMapLayers {
  OpenStreetMaps = "OpenStreetMaps",
  BiN = "BiN",
  Ideib = "Ideib",
  Ortofoto = "Ortofoto",
}

export enum MapLayersType {
  None = "None",
  Water = "Water",
  Precipitation = "Precipitation",
  Rivers = "Rivers",
  T010 = "T010",
  T100 = "T100",
  T500 = "T500",
  Calat = "Calat",
  Calat_T010 = "Calat_T010",
  Calat_T100 = "Calat_T100",
  Calat_T500 = "Calat_T500",
  IndexArrossegamentPeatons = "IndexArrossegamentPeatons",
  IndexArrossegamentPeatons_T010 = "IndexArrossegamentPeatons_T010",
  IndexArrossegamentPeatons_T100 = "IndexArrossegamentPeatons_T100",
  IndexArrossegamentPeatons_T500 = "IndexArrossegamentPeatons_T500",
  IndexArrossegamentVehicles = "IndexArrossegamentVehicles",
  IndexArrossegamentVehicles_T010 = "IndexArrossegamentVehicles_T010",
  IndexArrossegamentVehicles_T100 = "IndexArrossegamentVehicles_T100",
  IndexArrossegamentVehicles_T500 = "IndexArrossegamentVehicles_T500",
  Velocitat = "Velocitat",
  AreaInundable = "AreaInundable",
  AreaInundable_T010 = "AreaInundable_T010",
  AreaInundable_T100 = "AreaInundable_T100",
  AreaInundable_T500 = "AreaInundable_T500",
  Velocitat_T010 = "Velocitat_T010",
  Velocitat_T100 = "Velocitat_T100",
  Velocitat_T500 = "Velocitat_T500",
  ZonaFluxPreferent = "ZonaFluxPreferent",
  Equipaments = "Equipaments",
  Soterrani = "Soterrani",
  PlantaBaixa = "PlantaBaixa",
}

export enum MapLayersWMS {
  None = "None",
  Water1h = "Water1h",
  Water24h = "Water24h",
  Precipitation1h = "Precipitation1h",
  Precipitation24h = "Precipitation24h",
  RiversZoomIn = "RiversZoomIn",
  RiversZoomOut = "RiversZoomOut",
}

export enum AllFloodsLayers {
  None = "None",
  Calat_T010 = "Calat_T010",
  Calat_T100 = "Calat_T100",
  Calat_T500 = "Calat_T500",
  IndexArrossegamentPeatons_T010 = "IndexArrossegamentPeatons_T010",
  IndexArrossegamentPeatons_T100 = "IndexArrossegamentPeatons_T100",
  IndexArrossegamentPeatons_T500 = "IndexArrossegamentPeatons_T500",
  IndexArrossegamentVehicles_T010 = "IndexArrossegamentVehicles_T010",
  IndexArrossegamentVehicles_T100 = "IndexArrossegamentVehicles_T100",
  IndexArrossegamentVehicles_T500 = "IndexArrossegamentVehicles_T500",
  Velocitat_T010 = "Velocitat_T010",
  Velocitat_T100 = "Velocitat_T100",
  Velocitat_T500 = "Velocitat_T500",
  AreaInundable_T010 = "AreaInundable_T010",
  AreaInundable_T100 = "AreaInundable_T100",
  AreaInundable_T500 = "AreaInundable_T500",
  ZonaFluxPreferent = "ZonaFluxPreferent",
}

export enum FloodLayers {
  None = "None",
  T010 = "T010",
  T100 = "T100",
  T500 = "T500",
  ZonaFluxPreferent = "ZonaFluxPreferent",
}

export enum DragRiskLayers {
  None = "None",
  IndexArrossegamentVehicles = "IndexArrossegamentVehicles",
  IndexArrossegamentPeatons = "IndexArrossegamentPeatons",
}

export enum EquipamentsLayers {
  None = "None",
  Equipaments = "Equipaments",
}

export enum PlantesBaixesLayers {
  None = "None",
  PlantaBaixa = "PlantaBaixa",
}

export enum SoterranisLayers {
  None = "None",
  Soterrani = "Soterrani",
}

export enum DataModes {
  WaterLevel = "WaterLevel",
  Precipitation1h = "Precipitation1h",
  Precipitation24h = "Precipitation24h",
  DischargeObserved = "DischargeObserved",
  DischargePredicted = "DischargePredicted",
}

export enum DataModeVariable {
  None = "None",
  WaterLevel = "WaterLevel",
  Precipitation = "Precipitation",
  Discharge = "Discharge",
}

export enum DataModeTime {
  None = "",
  LastRecived = "LastRecived",
  Time1h = "1h",
  Time2h = "2h",
  Time3h = "3h",
  Time6h = "6h",
  Time12h = "12h",
  Time24h = "24h",
  Time36h = "36h",
  Time48h = "48h",
}

export enum DataModeType {
  Observed = "Observed",
  Predicted = "Predicted",
}

export enum IslandsNames {
  Pitiuses = "Illes Pitiüses",
  Mallorca = "Mallorca",
  Menorca = "Menorca",
  Formentera = "Formentera",
}

export enum CatchmentNames {
  Gros = "Gros",
  Major = "Major",
  SantaEularia = "Santa Eulària",
}
